export default __webpack_public_path__ + "static/media/170.50f2af25.png";